import * as autosuggestModels from 'actions/AutosuggestActions/Utils';
import { SUCCESS } from 'utils/asyncStatusHelper';
import get from 'lodash/get';
import { WidgetTypeV4 } from '@rome/response/page/v4/WidgetTypeV4';
import { addURLSearchParams } from 'utils/urlutils';
const { autosuggestVersion } = autosuggestModels;
export const getNavigationUrlFromAction = (contentType, action, tracking) => {
    let url = '';
    const urlSearchParams = {};
    if (action && action.url) {
        let otracker = tracking.otracker || '';
        let otracker1 = tracking.otracker1 || '';
        const sid = tracking.suggestionId || '';
        const rid = tracking.requestId || '';
        const position = tracking.position;
        url = action.url;
        if (otracker) {
            urlSearchParams['otracker'] = otracker.replace('{POSITION}', position.toString());
        }
        if (otracker1) {
            urlSearchParams['otracker1'] = otracker1.replace('{POSITION}', position.toString());
        }
        if (url.indexOf('as') === -1) {
            urlSearchParams['as'] = 'on';
        }
        if (url.indexOf('as-show') === -1) {
            urlSearchParams['as-show'] = 'on';
        }
        if (url.indexOf('as-pos') === -1) {
            urlSearchParams['as-pos'] = position.toString();
        }
        if (contentType && url.indexOf('as-type') === -1) {
            urlSearchParams['as-type'] = contentType;
        }
        if (url.indexOf('suggestionId') === -1 && sid) {
            urlSearchParams['suggestionId'] = sid;
        }
        if (url.indexOf('requestId') === -1 && rid) {
            urlSearchParams['requestId'] = rid;
        }
    }
    url = addURLSearchParams(url, urlSearchParams);
    return url;
};
export const getSubtitleValue = (store, type) => {
    switch (type) {
        case WidgetTypeV4.AUTOSUGGEST_CLP_WIDGET:
        case WidgetTypeV4.AUTOSUGGEST_PRODUCT_WIDGET:
        case WidgetTypeV4.AUTOSUGGEST_RICH_WIDGET:
            return store.subTitle || '';
        case WidgetTypeV4.AUTOSUGGEST_QUERY_STORE_WIDGET:
            const value = store;
            let text = value.store;
            if (value.filters) {
                text = `${text} . ${value.filters}`;
            }
            return text;
        default:
            return '';
    }
};
const prepareResponse = function (suggestions, queryWord, marketplace, searchHistory) {
    const store = [];
    /*
        Position value is assigned to the auto suggest list items. There are items in
        the list which are non-clickable, i.e. their "action" property is null. For
        such items the "positionCounter" variable will not be incremented. Only items
        with a non null actions, i.e. have a URL need to be tracked.
    */
    let positionCounter = queryWord ? 0 : searchHistory.length;
    suggestions.slice(0, 8).map(suggestion => {
        const component = get(suggestion, ['data', 'component']);
        const value = get(component, ['value']);
        const subTitle = getSubtitleValue(value, suggestion.type);
        const imageUrl = value.imageUrl || '';
        const contentType = get(value, ['contentType']) || '';
        const backfill = value.backFill || queryWord;
        let action = get(component, ['action']);
        let url = get(action, ['url']) || '';
        let tracking = Object.assign({}, get(component, ['action', 'tracking']), get(suggestion, ['tracking']));
        if (action) {
            positionCounter += 1;
            tracking.position = positionCounter.toString();
            url = getNavigationUrlFromAction(contentType, action, tracking);
        }
        const marketPlaceId = get(action, ['params', 'marketplace']) || marketplace;
        const suggestionValue = {
            title: value.title,
            subTitle,
            imageUrl,
            query: queryWord,
            template: suggestion.type,
            contentType,
            backfill,
            navigationUrl: url,
            type: value.type
        };
        const item = {
            action,
            tracking,
            value: suggestionValue,
            marketplace: marketPlaceId,
            userTimeStamp: Date.now(),
            version: autosuggestVersion.V4
        };
        if (__DEBUG_ENV__) {
            item.originalObject = suggestion;
        }
        store.push(item);
    });
    return store;
};
export default (action, state) => {
    const tmp = state.words || {};
    const payloadId = get(action, ['data', 'RESPONSE', 'payloadId']) || '';
    const suggestions = get(action, ['data', 'RESPONSE', 'suggestions']) || {};
    const queryWord = get(action, ['query']) || '';
    const marketPlace = get(action, ['marketplace']);
    const responseTimeInMS = get(action, ['responseTimeInMS']);
    const organisedResponse = prepareResponse(suggestions, queryWord, marketPlace, state.searchHistory);
    organisedResponse && (tmp[`${queryWord} - ${marketPlace}`] = organisedResponse);
    return Object.assign({}, state, {
        asyncStatus: SUCCESS,
        query: action.query,
        payloadId,
        words: tmp,
        responseTimeInMS
    });
};
